import React from "react";
import { BodyPhotoShareDto } from "../../../../../types/types";
import BodyPhotoShare from "./BodyPhotoShare";

interface BodyPhotoSharesShowProps {
  shares: BodyPhotoShareDto[];
}

const BodyPhotoSharesShow: React.FC<BodyPhotoSharesShowProps> = ({ shares }) => {
  if (shares.length === 0) {
    return null;
  }

  return (
    <div style={{ display: "flex", flexWrap: "wrap", gap: 8 }}>
      {shares.map((share, index) => (
        <BodyPhotoShare
          key={`${share.userId}-${index}`}
          share={share}
        />
      ))}
    </div>
  );
};

export default BodyPhotoSharesShow;
